<template>
  <section id="ies3">
    <BackgroundImage
      class="card border-0 ies3"
      :src="backgroundImgIes2"
      styles="min-height: 46vw;"
    >
      <div class="d-flex align-items-start cardImgWrapper">
        <div class="card-body">
          <div class="container text-left ies3BulletArrowListWrapper">
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 d-none d-md-block">
              <ul class="bulletArrow  wow fadeInLeft">
                <li
                  class="ies3BulletArrowList"
                  v-for="(headline, index) in listHeadlineElements"
                  :key="index"
                >
                  <span class="fontbold">{{ $t(headline) + ":" }} </span
                  ><span
                    class="fontp"
                    v-html="$t(listSmallElements[index])"
                  ></span>
                </li>
                <PdfDocument name="prospekt">
                  <LabeledButton :label="$t('Learn_more')" icon="book" />
                </PdfDocument>
              </ul>
            </div>

            <div class="col-10  d-md-none mobileListWrapper">
              <ul class="bulletArrow">
                <li
                  class="ies3BulletArrowListMobile"
                  v-for="headlineMobile in listHeadlineElementsForMobile"
                  :key="headlineMobile"
                >
                  <span class="fontbold">{{ $t(headlineMobile) }} </span>
                </li>
                <PdfDocument name="prospekt">
                  <LabeledButton
                    class="ies3__learnmorebutton"
                    :label="$t('Learn_more')"
                    icon="book"
                  />
                </PdfDocument>
              </ul>
            </div>
          </div>
        </div>
        <GreenInformationCircle />
      </div>

      <div
        class="productHoverArea"
        @mouseenter="makeBoxWithProductNrVisibil"
        @mouseleave="hideBoxWithProductNr"
      ></div>

      <div
        class="card-body productNumberContainer"
        v-if="isBoxWithProductNrVisible"
      >
        <div class="container-fluid d-none d-lg-block">
          <div class="col-lg-12 productNumberInfoboxWrapper">
            <p class="liFontSmallBlack ">
              {{ $t("smoke_evacuation_system") }}
            </p>
            <div class="row">
              <div class="col-5 liFontSmallBold">
                10323-000
              </div>
              <div class="col-7 liFontSmallLight">
                {{ $t("IES3_smoke_evacuation_system") }}
              </div>
            </div>
            <hr class="productNumberInfoboxSeperator" />
            <div class="row">
              <div class="col-5 liFontSmallBold">
                20323-000
              </div>
              <div class="col-7 liFontSmallLight">
                {{ $t("main_filter_catridge") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProductTrailer />

      <img
        class="awardImg"
        src="@/assets/images/gda2020.png"
        v-bind:alt="$t('smoke_evacuation_system_ies_3')"
      />
    </BackgroundImage>
  </section>
</template>

<script>
import LabeledButton from "@/components/LabeledButton";
import BackgroundImage from "@/components/BackgroundImage";
import GreenInformationCircle from "./GreenInformationCircle";
import ProductTrailer from "./ProductTrailer";
import PdfDocument from "@/components/PdfDocument";

export default {
  name: "IES3",
  components: {
    LabeledButton,
    GreenInformationCircle,
    ProductTrailer,
    BackgroundImage,
    PdfDocument
  },
  data() {
    return {
      isBoxWithProductNrVisible: false,
      listSmallElements: [
        "core_component_ulpa_15_filter",
        "new_bi_turbo_technology",
        "usages_open_and_laparoscopic_applications",
        "dispay_all_parameters"
      ]
    };
  },
  computed: {
    buttonProspektImageUrl() {
      return this.$store.getters.image_button_prospekt;
    },
    listHeadlineElements() {
      return [
        "ulpa_15_filter_protection",
        "excellent_response",
        "range_of_applications",
        "easy_use"
      ];
    },
    listHeadlineElementsForMobile() {
      return [
        "ulpa_15_filter_protection",
        "excellent_response",
        "range_of_applications",
        "easy_use",
        "system_variable_one_source"
      ];
    },
    backgroundImgIes2() {
      return this.$store.getters.image_background_ies_2;
    }
  },
  methods: {
    makeBoxWithProductNrVisibil() {
      this.isBoxWithProductNrVisible = true;
    },
    hideBoxWithProductNr() {
      this.isBoxWithProductNrVisible = false;
    }
  }
};
</script>

<style scoped>
.cardImgWrapper {
  position: relative;
}
.productNumberInfoboxSeperator {
  border: solid 1px #95d5d1;
}
.ies3 {
  overflow: hidden;
  border-radius: 0;
}
.ies3BulletArrowList {
  padding-top: 10px;
  letter-spacing: 1px;
}

.ies3BulletArrowList:first-of-type {
  padding-top: 0;
  letter-spacing: 1px;
}

.ies3BulletArrowListMobile {
  color: black;
  letter-spacing: 1px;
}

.productNumberInfoboxWrapper {
  background-color: white;
  padding: 20px !important;
  border-radius: 10px;
  opacity: 0.8;
}

.ies3BulletArrowListWrapper {
  margin: 0;
  padding: 0;
}
.productHoverArea {
  position: absolute;
  top: 25%;
  right: 23%;
  left: 60%;
  bottom: 30%;
  background-color: transparent;
  z-index: 3;
}
.productNumberContainer {
  position: absolute;
  top: 5%;
  right: 1%;
  z-index: 2;
}
.awardImg {
  position: absolute;
  right: 0;
  top: 1rem;
  width: 16vw;
  padding: 1vw;
  background-color: white;
}
.card-body {
  min-height: 260px;
}
.mobileListWrapper .bulletArrow {
  padding: 0;
}

.ies3__learnmorebutton {
  margin-top: 1rem;
}

@media (max-width: 575.98px) {
  .ies3 {
    background-position: 70%;
  }
  .cardImgWrapper {
    padding-left: 0;
  }
  .card-body {
    padding-left: 0;
  }
  .mobileListWrapper {
    padding-left: 1.6rem;
    padding-right: 3rem;
  }
  .awardImg {
    width: 20vw;
  }
  .mobileListWrapper li::before {
    font-size: 1rem;
    line-height: 1.5rem;
    padding-left: 0;
  }
  .mobileListWrapper li span {
    font-size: 0.7rem;
  }
}

@media (min-width: 992px) {
  .bulletArrow {
    margin-left: 3rem;
  }
}
@media (min-width: 1200px) {
  .ies3BulletArrowListWrapper {
    padding-top: 4rem;
  }
}
@media (min-width: 1600px) {
  .ies3BulletArrowListWrapper {
    padding-top: 4rem;
    padding-left: 6rem;
  }
}
</style>
